// AXIOS
import axios from "axios";

import { apiUrl_forGoogleCategories, apiToken } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get google categories
export let cancelGetGoogleShoppingCategoriesApi;
export async function getGoogleShoppingCategories() {
    const data = await axios.get(
        apiUrl_forGoogleCategories + "googleshop/categories",
        {
            headers: {
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetGoogleShoppingCategoriesApi = c;
            }),
        }
    );

    return data;
}

// set google categories
export let cancelSetGoogleShoppingCategoriesApi;
export async function setGoogleShoppingCategories(
    commonToken,
    { category, breadcrumb, product_type }
) {
    if (commonToken && category && product_type) {
        const data = await axios.put(
            apiUrl_forGoogleCategories + "googleshop/categories",
            {
                google_shop_data: {
                    category,
                    breadcrumb,
                    product_type,
                },
            },
            {
                headers: {
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelSetGoogleShoppingCategoriesApi = c;
                }),
            }
        );
        return data;
    }
}
// set google settings
export let cancelGetGoogleSettingsCategoriesApi;
export async function getGoogleShoppingSettings() {
    const data = await axios.get(apiUrl_forGoogleCategories + "googleshop", {
        headers: {
            "Api-Token": apiToken,
            "Access-Token": "",
        },
        cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancelGetGoogleSettingsCategoriesApi = c;
        }),
    });

    return data;
}
